import { render, staticRenderFns } from "./CommitteeStructureReportPreview.vue?vue&type=template&id=bd17a6b8&scoped=true"
import script from "./CommitteeStructureReportPreview.vue?vue&type=script&lang=ts"
export * from "./CommitteeStructureReportPreview.vue?vue&type=script&lang=ts"
import style0 from "./CommitteeStructureReportPreview.vue?vue&type=style&index=0&id=bd17a6b8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd17a6b8",
  null
  
)

export default component.exports